import styled, { css } from "styled-components"
import { darken, mix } from "polished"

export const StyledDiv = styled.div`
  font-family: ${(props) => props.theme.fonts.body.family}, sans-serif;

  .rmsc .dropdown-container {
    border-width: 2px;
    border-radius: 10px;
    border-color: transparent;
    color: #000;

    .dropdown-heading {
      height: unset;
      padding: 4px 10px 4px 2px;
      border-radius: 8px;
    }

    .dropdown-heading-value {
      padding: 5px 8px;

      & > span > span.text {
        padding: calc(0.75rem - 9px) calc(1.25rem - 10px);
      }

      & > span {
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
    }

    .dropdown-content,
    .rmsc .options {
      color: #000;
    }

    .select-item {
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: start;
      padding: 12px 16px;
      outline-offset: 0;
    }

    .select-item:hover {
      background: #f2f2f2;
    }
  }

  ${({ theme }) => css`
    .rmsc.invalid .dropdown-container {
      border-color: ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
      background-color: ${mix(0.95, "#fff", theme.colors.danger)};
      color: ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
    }

    .rmsc.invalid .dropdown-container .gray {
      color: ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
    }
  `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      .rmsc .dropdown-container {
        .dropdown-heading {
          padding: 12px 10px 12px 16px;
          border: 1px solid #e6e6e6;
        }

        .dropdown-heading-value {
          padding: 0 10px 0 0;

          & > span > span.text {
            padding: 0;
          }
        }
      }
    `}
`

export const Item = styled.div``

export const Token = styled.span`
  background: #f2f2f2;
  color: #333333;
  font-size: 14px;
  font-weight: 400;
  padding: 6px 14px;
  border-radius: 6px;
  line-height: 150%;
`

export const ClearSelected = styled.span`
  cursor: pointer;
  padding-right: 5px;
  color: ${(props) => props.theme.colors.primary};
`
